var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkModeDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97363 5.96875L7.0403 23.0354C7.09097 24.0216 7.8083 24.7421 8.74697 24.7421H18.5603C19.5027 24.7421 20.2067 24.0216 20.267 23.0354L21.3336 5.96875",
    stroke: "white",
    strokeWidth: 1.70667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2666 5.96875H23.0399Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2666 5.96875H23.0399",
    stroke: "white",
    strokeWidth: 1.70667,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4935 9.38527L17.0668 21.3319M10.2401 5.97193V3.8386C10.2397 3.67037 10.2724 3.5037 10.3366 3.34818C10.4007 3.19266 10.495 3.05136 10.6139 2.9324C10.7329 2.81345 10.8742 2.71918 11.0297 2.65503C11.1852 2.59088 11.3519 2.55811 11.5201 2.5586H15.7868C15.955 2.55811 16.1217 2.59088 16.2772 2.65503C16.4327 2.71918 16.5741 2.81345 16.693 2.9324C16.812 3.05136 16.9062 3.19266 16.9704 3.34818C17.0345 3.5037 17.0673 3.67037 17.0668 3.8386V5.97193H10.2401ZM13.6535 9.38527V21.3319V9.38527ZM9.81348 9.38527L10.2401 21.3319L9.81348 9.38527Z",
    stroke: "white",
    strokeWidth: 1.70667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkModeDeleteIcon);
export default __webpack_public_path__ + "static/media/Dark_Mode_Delete_Icon.634e4b191766ebbaaacf9250a8006023.svg";
export { ForwardRef as ReactComponent };